//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

// Our APIs often return userTags / labels as a single
// comma-separated string, whereas our frontend code
// usually requires a list of strings. These functions
// enable quick conversion between the two.
export const toLabelsArray: (labels: string) => string[] | undefined = (
  labels,
) => {
  if (labels) {
    return labels.split(',').map((x) => x.trim());
  } else {
    return undefined;
  }
};

export const toLabelsString: (labels: string[]) => string | undefined = (
  labels,
) => {
  if (labels.length) {
    return labels.join(',');
  } else {
    return undefined;
  }
};
